import type { IXY } from './distanceUtil'

export function calcAngleToXY(a: IXY, b: IXY) {
  return Math.atan2(b.y - a.y, b.x - a.x)
}

export function calcAngleToXYLead(a: IXY, b: IXY, ox: number, oy: number) {
  return Math.atan2(b.y - a.y + oy, b.x - a.x + ox)
}

// export function shortestArc(a: number, b: number) {
//   if (Math.abs(b - a) < Math.PI) {
//     return b - a
//   }
//   if (b > a) {
//     return b - a - Math.PI * 2.0
//   }
//   return b - a + Math.PI * 2.0
// }

function findTurnSide(a: number, b: number) {
  let diff = b - a
  if (diff < 0) {
    diff += Math.PI * 2
  }
  if (diff > Math.PI) {
    return -1
  } // Left
  return 1 // Right turn
}

export function normalizeAngle(a: number) {
  let pi2 = Math.PI * 2
  if (a > pi2) {
    a -= Math.floor(a / pi2) * pi2
  }
  if (a < 0) {
    a += Math.ceil(-a / pi2) * pi2
  }
  return a
}

export function angleTowards(
  curAngle: number,
  targetAngle: number,
  max: number,
) {
  curAngle = normalizeAngle(curAngle)
  targetAngle = normalizeAngle(targetAngle)

  // Don't overshoot
  let diff = normalizeAngle(curAngle - targetAngle)
  if (Math.abs(diff) < max) {
    return targetAngle
  }

  let dir = findTurnSide(curAngle, targetAngle)
  curAngle += dir * max

  return normalizeAngle(curAngle)
}

export function angleDifference(a: number, b: number) {
  return normalizeAngle(b - a)
}

export function isAngleDifferenceWithin(a: number, b: number, e: number) {
  return angleLessThan(normalizeAngle(normalizeAngle(b) - normalizeAngle(a)), e)
}

export const turn = Math.PI * 2

export function angleLessThan(a: number, e: number) {
  if (a < e) {
    return true
  }
  if (a > Math.PI * 2 - e) {
    return true
  }
  return false
}
